
const HOST : string = "localhost";
const PORT : number = 3500;

export {HOST, PORT}